import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=d44b98fa&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=js&"
export * from "./CouponItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=d44b98fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44b98fa",
  null
  
)

export default component.exports